import React from 'react';
import CybsChip from '@cybs-ui/components/lib/chip';
import {connect} from 'react-redux';

class LifeCycle extends React.Component{

  render () {
    return (
      <span>
        {(() => {
          if (this.props.thirdLevelApiLifeCycle != null && this.props.thirdLevelApiLifeCycle != undefined &&this.props.thirdLevelApiLifeCycle != '') {
            return (
              <CybsChip className = "bg_color_theme_primary border_color_theme_primary" dataTest="lifeCycle">{this.props.thirdLevelApiLifeCycle.toUpperCase()}</CybsChip>
            )
          }
          else {
            return (
               <span></span> 
            )
          }
        })()}
      </span>
    )
  }

}


function mapStateToProps(state){
  return{
    thirdLevelApiLifeCycle: state.lhsReducer.thirdLevelApiLifeCycle
  }
}

export default connect(mapStateToProps)(LifeCycle);
